"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_STOP = exports.WS_SEND = exports.WS_RECONNECT_FAILED = exports.WS_LAUNCH = exports.WS_ERROR = exports.WS_END = exports.WS_CONNECTING = exports.WS_CONNECT = exports.WS_CLOSE = exports.SERVER_INFO = void 0;
var SERVER_INFO = exports.SERVER_INFO = 'SERVER_INFO';
var WS_CONNECT = exports.WS_CONNECT = 'WS_CONNECT';
var WS_CONNECTING = exports.WS_CONNECTING = 'WS_CONNECTING';
var WS_RECONNECT_FAILED = exports.WS_RECONNECT_FAILED = 'WS_RECONNECT_FAILED';
var WS_CLOSE = exports.WS_CLOSE = 'WS_CLOSE';
var WS_END = exports.WS_END = 'WS_END';
var WS_ERROR = exports.WS_ERROR = 'WS_ERROR';
var WS_LAUNCH = exports.WS_LAUNCH = 'WS_LAUNCH';
var WS_SEND = exports.WS_SEND = 'WS_SEND';
var WS_STOP = exports.WS_STOP = 'WS_STOP';